module.exports = __webpack_public_path__ + "img/dreEoJDH.c524e08b.svg";